import { ToastController } from '@ionic/angular/standalone';
import { Injectable } from '@angular/core';
import { ERROR_MESSAGES } from '@app/constants/message.constants';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(public toastController: ToastController) {}

  success(message: string, duration?: number): void {
    this.toastController
      .create({
        position: 'bottom',
        duration: duration ? duration : 2000,
        message,
        color: 'success',
      })
      .then((toast) => {
        toast.present().then((r) => {});
      });
  }

  error(message: string, duration?: number, header?: string): void {
    this.toastController
      .create({
        position: 'bottom',
        duration: duration ? duration : 2000,
        message,
        color: 'danger',
        header,
      })
      .then((toast) => {
        toast.present().then((r) => {});
      });
  }

  showApiError(errorResponse: any, duration?: number): string {
    if (!duration) {
      duration = 4000;
    }
    if (errorResponse?.error?.errorCode) {
      this.error(errorResponse?.error?.errorMessage, duration);
      return errorResponse?.error?.errorMessage;
    } else {
      if (errorResponse?.status === 404) {
        this.error(ERROR_MESSAGES.DATA_NOT_FOUND, duration);
        return ERROR_MESSAGES.DATA_NOT_FOUND;
      } else if (errorResponse?.status) {
        this.error(ERROR_MESSAGES.TOO_MANY_RESEND_OTP_REQUEST, duration);
        return ERROR_MESSAGES.TOO_MANY_RESEND_OTP_REQUEST;
      } else {
        this.error('Something went wrong. Please try again!', duration);
        return 'Something went wrong. Please try again!';
      }
    }
  }
}
